import React from "react";

const AccountSettings = ({
  profile,
  setProfile,
  username,
  token,
  editingUsername,
  setEditingUsername,
  newUsername,
  setNewUsername,
  editingEmail,
  setEditingEmail,
  email,
  newEmail,
  setNewEmail,
  editingPassword,
  setEditingPassword,
  oldPassword,
  setOldPassword,
  newPassword,
  setNewPassword,
  confirmNewPassword,
  setConfirmNewPassword,
}) => {
  return (
    <>
      {/* Avatar */}
      <div>
        <label className="block font-semibold text-accent mb-2">Avatar</label>
        {profile.avatar_url ? (
          <img
            src={
              profile.avatar_url.startsWith("http")
                ? profile.avatar_url
                : `${process.env.REACT_APP_API_URL}${profile.avatar_url}`
            }
            alt="Avatar"
            className="w-20 h-20 sm:w-24 sm:h-24"
          />
        ) : (
          <p className="text-sm text-gray-500">No avatar uploaded</p>
        )}
        <input
          type="file"
          accept="image/*"
          onChange={async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append("file", file);

            const res = await fetch(
              `${process.env.REACT_APP_API_URL}/users/me/profile/avatar`,
              {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
              }
            );

            if (res.ok) {
              const data = await res.json();
              setProfile({ ...profile, avatar_url: data.avatar_url });
            } else {
              alert("Failed to upload avatar");
            }
          }}
        />
      </div>

      {/* Username */}
      <div>
        <label className="block text-accent font-semibold mb-2">Username</label>
        {!editingUsername ? (
          <div className="flex items-center justify-between">
            <span>{username}</span>
            <button
              onClick={() => setEditingUsername(true)}
              className="btn-full"
            >
              Edit
            </button>
          </div>
        ) : (
          <div className="flex items-center space-x-2">
            <input
              type="text"
              value={newUsername}
              onChange={(e) => setNewUsername(e.target.value)}
              className="w-full sm:w-auto"
              placeholder="Enter new username"
            />
            <button
              onClick={() => setEditingUsername(false)}
              className="btn-full"
            >
              Cancel
            </button>
          </div>
        )}
      </div>

      {/* Email */}
      <div>
        <label className="block text-accent font-semibold mb-2">E-mail</label>
        {!editingEmail ? (
          <div className="flex items-center justify-between">
            <span>{email}</span>
            <button
              onClick={() => setEditingEmail(true)}
              className="btn-full"
            >
              Edit
            </button>
          </div>
        ) : (
          <div className="flex items-center space-x-2">
            <input
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              className="w-full sm:w-auto"
              placeholder="Please enter a new email"
            />
            <button
              onClick={() => setEditingEmail(false)}
              className="btn-full"
            >
              Cancel
            </button>
          </div>
        )}
      </div>

      {/* Password */}
      <div>
        <label className="block text-accent font-semibold mb-2">Password</label>
        {!editingPassword ? (
          <div className="flex items-center justify-between">
            <span>********</span>
            <button
              onClick={() => setEditingPassword(true)}
              className="btn-full"
            >
              Edit
            </button>
          </div>
        ) : (
          <div className="space-y-3 sm:flex sm:items-center sm:space-x-2 sm:space-y-0">
            <input
              type="password"
              placeholder="Enter old password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="w-full sm:w-auto"
            />
            <input
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full sm:w-auto"
            />
            <input
              type="password"
              placeholder="Re-enter new password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              className="w-full sm:w-auto"
            />
            <button
              onClick={() => setEditingPassword(false)}
              className="btn-full"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default AccountSettings;
